import axios from '@/axios'

axios.defaults.baseURL = process.env.VUE_APP_CMS_URL

export default axios
